import InlineSVG from 'react-inlinesvg';
import infoIcon from '../assets/svg/link-new-tab.svg';

const FormV2InfoTooltip = ({
    info,
    className = '',
    style = {},
    position = 'right',
}) => {

    if (!info) return null;
    return (
        <div className={`formV2-tooltip-container ${className}`} style={style}>
            <InlineSVG src={infoIcon} />
            <span className={`formV2-tooltip formV2-tooltip-${position}`}>{info}</span>
        </div>
    )
}

export default FormV2InfoTooltip